<span
  class="shared-tooltip"
  [tooltipPosition]="tooltipPosition"
  [showDelay]="showDelay"
  [hideDelay]="hideDelay"
  [pTooltip]="tooltipContent"
  [tooltipStyleClass]="
    theme === 'light' ? 'shared-tooltip-light' : 'shared-tooltip-dark'
  "
>
  <ng-content />
</span>

<!-- Render template only when content is TemplateRef -->
<ng-container *ngIf="isTemplateRef(tooltipContent)">
  <ng-container *ngTemplateOutlet="tooltipContent" />
</ng-container>
